import { Component, OnInit, ViewChild, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';

import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import { MessageError } from 'base-models';
import { AlertType } from 'base-models';
import { Site } from 'solar-bo';

import { DialogdeleteComponent } from 'basecomponents';
import { AppInjector } from 'base-models';
import { ErrorcontrolService } from 'basecomponents';
import { SolarService } from '../../services/solarservice.service';
import { SiteUploadComponent } from './site-upload/site-upload.component';

import { UploadFileData } from 'guploadmgr';
import { UploadInfo, UploadTypeEnum } from 'guploadmgr';
import { SolarBase1Component } from '@solar/solar/solar-base';



@Component({
  selector: 'app-site-files',
  templateUrl: './site-files.component.html',
  styleUrls: ['./site-files.component.scss']
})
export class SiteFilesComponent extends SolarBase1Component implements OnInit, OnChanges {
  
  @Input() site:Site;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  

  displayedColumns = ['name','filetype','filesize', 'creation_date', 'actions'];
  dataSource = new MatTableDataSource<any>(this.listOriginal);
  filteredList: any;
  highlightedRows = [];

  //public dialog: MatDialog;
  public solarService: SolarService;

  public constructor() {  
    super();
    const injector = AppInjector.getInjector();   
    //this.dialog = injector.get(MatDialog);
    this.solarService = injector.get(SolarService);

  }

  ngOnInit() {
    console.log("SiteFilesListComponent ngOnInit", this.site);
      this.getList();   
  }

  ngOnChanges(changes: SimpleChanges) {
    const typeChange = changes['site'];
    if ((typeChange && !typeChange.firstChange) && typeChange.currentValue != undefined) {
      this.getList();
    }
  }

  refresh(){
    this.getList();
  }

  getList(): void {
    if (!this.site){
      return;
    }
    this.listerrmessage = "";
    this.loading = true;

    this.solarService.siteGetFilesById(this.site.id)
      .subscribe(
        reslist => this.getListhandleresult(reslist)
        , err => this.getListhandleError(err)
      );
  }

  getListhandleresult(newlist: any[]) {
    console.log('getListhandleresult', newlist);
    this.listerrmessage = '';
    this.loading = false;
   
/*     for (let elem of newlist){
      elem.id_site=this.supervision.site.id;
    } */
    this.listOriginal = newlist;
    this.configsource();
    this.alertmessage = null;
  }
  getListhandleError<T>(err: any) {
    console.log("getListhandleError");
    this.loading = false;
    this.alertmessage=ErrorcontrolService.basichandleError("", err);
  }

  configsource() {
    this.dataSource = new MatTableDataSource<any>(this.listOriginal);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  uiisdeletable(element: any) {
    return true;
  }

  itemSelected(item: Site) {
    this.selectedItemEvent.next(item);
  }


  openDialogDeleteFile(model){
    let dialogRef = this.openDialogDelete("Delete File", "Do you want to delete file: " + model.name, model);
    dialogRef.componentInstance.mainActionEmitter.subscribe(() => this.deleteFileHandler(model, dialogRef));
  }

  deleteFileHandler(model: UploadFileData, dialogRef: MatDialogRef<DialogdeleteComponent>, ) {
    const dlgComp = dialogRef.componentInstance;
    dlgComp.lockdeletebtn();
    dialogRef.close();
    this.loadinglist = true;
    this.alertmessage = new MessageError(AlertType.Warning, "Deleting file, please wait");
    this.solarService.deleteResourceById(model.id).subscribe(
      () => this.deleteFileSucessHandler(model.id)
      , err => this.handleError(err, "Error deleting file "));
  }

  deleteFileSucessHandler(id: string) {
    const index = this.listOriginal.findIndex(el => el.id == id, 0);
    if (index > -1) {
      this.listOriginal.splice(index, 1);
      this.configsource();
    }
    this.handleSuccesLoad("File deleted");
  }

  openDialogAddFilesTo() {
    let dialogRef: MatDialogRef<SiteUploadComponent>;

    let uploadinfo: UploadInfo = new UploadInfo();
    uploadinfo.parentid = this.site.id;
    uploadinfo.parentname = this.site.name;
    uploadinfo.id = this.site.id;
    uploadinfo.upload_type = UploadTypeEnum.site_info;

    dialogRef = SiteUploadComponent.openModalWithModel(this.dialog, this.site, uploadinfo);
  }
}

